var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "cloud-compass_svg__cloud-insights_svg__Layer_1",
    width: 24,
    height: 24,
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cloud-compass_svg__cloud-insights_svg__cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;fill:none;stroke-width:.75px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.77 14.47c-.54-.74-1.36-1.24-2.27-1.42-.66.33-1.39.51-2.18.51-2.02 0-3.76-1.22-4.51-2.97-2.37.46-3.14 2.39-3.14 2.39-1.36-.14-2.69.43-3.45 1.48-.74 1.02-.71 2.35.06 3.34.67.87 1.52 1.11 2.87 1.26.18.02.37.03.55.03h.71s3.61 2.6 7.18 0h.71c.18 0 .37 0 .55-.03 1.34-.15 2.19-.39 2.87-1.26.77-1 .79-2.33.06-3.34Z",
    className: "cloud-compass_svg__cloud-insights_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.32 3.74a4.912 4.912 0 0 0-4.51 6.85 4.904 4.904 0 0 0 6.69 2.46 4.9 4.9 0 0 0 2.73-4.4c0-2.71-2.2-4.91-4.91-4.91",
    className: "cloud-compass_svg__cloud-insights_svg__cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m15.19 12.14-.47-2.92-2.92-.47c-.16-.02-.16-.25 0-.27l2.92-.47.47-2.92c.02-.16.25-.16.27 0l.47 2.92 2.92.47c.16.02.16.25 0 .27l-2.92.47-.47 2.92c-.02.16-.25.16-.27 0",
    style: {
      strokeWidth: ".09px",
      fill: "#fff",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.56 10.36.67-1.69-.67-1.69c-.03-.07.04-.14.11-.11l1.69.67 1.69-.67c.07-.03.14.04.11.11l-.67 1.69.67 1.69c.03.07-.04.14-.11.11l-1.69-.67-1.69.67a.084.084 0 0 1-.11-.11",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".06px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCompass);
export default __webpack_public_path__ + "static/media/cloud-compass.7d152e97923fd593df7ae0706b55b412.svg";
export { ForwardRef as ReactComponent };